import { useTranslation } from "react-i18next";
import { TbCategory } from "react-icons/tb";

import { CommonLabel } from "@/components/CommonInput";
import CommonSelector, { CommonSelectorItem } from "@/components/CommonSelector";
import { notificationCategories } from "@/constants/notificationCategories";
import { NotificationCategories } from "@/types/global";

import { CreateNotificationFormType } from "./CreateNotificationForm";

const options = Object.values(NotificationCategories).filter((category) => typeof category === "string");
function CreateNotificationCategorySelector() {
    const { t } = useTranslation();

    return (
        <CommonLabel className="col-span-4" label={t("notificationCategory")}>
            <CommonSelector<CreateNotificationFormType, NotificationCategories>
                icon={TbCategory}
                name="category"
                options={options}
                getOptionLabel={(val) => {
                    return t("notification_categories." + (val || null));
                }}
                placeholder="notificationCategory"
                renderOption={({ option }) => {
                    return (
                        <CommonSelectorItem<NotificationCategories>
                            option={option}
                            options={notificationCategories}
                            prefix="notification_categories."
                        />
                    );
                }}
            />
        </CommonLabel>
    );
}

export default CreateNotificationCategorySelector;
